import { useState } from 'react';
import { useRouter } from 'next/router';
import { Text, Stack, Flex } from '@pairy/pds-react';

import { SetState } from '@/types/helper';
import useDeleteFile from '@/hooks/mutations/file/useDeleteFile';
import { addJosa } from '@/utils/josa';

import DeleteConfirmModal from '../../../../common/DeleteConfirmModal';

interface Props {
  isOpen: boolean;
  setIsOpen: SetState<boolean>;
  fileId: number;
  fileName: string;
}

const DeletePdfFileModal = ({ isOpen, setIsOpen, fileId, fileName }: Props) => {
  const router = useRouter();

  const deleteFile = useDeleteFile({
    onSuccess: () => {
      setIsLoading(false);
      if ('fileId' in router.query && 'clientId' in router.query) {
        router.reload();
        return;
      }
      if ('fileId' in router.query) {
        router.replace('/user/pdf');
      } else {
        router.reload();
      }
    },
  });

  const [isLoading, setIsLoading] = useState(false);

  const handleClickDeleteFile = () => {
    setIsLoading(true);
    deleteFile.mutate({ fileId });
  };

  return (
    <DeleteConfirmModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      onClick={handleClickDeleteFile}
      loading={isLoading}
      content={
        <Stack gap={10} direction="column">
          <Text as="p" variant="xl-semibold">
            {addJosa(fileName, '을')} 삭제하시겠습니까?
          </Text>

          <Flex direction="column">
            <Text variant="lg-medium">
              삭제 시,&nbsp;
              <Text variant="lg-semibold" as="span">
                {fileName}과 연결된 모든 링크가 동작하지 않습니다. 그래도
                삭제할까요?
              </Text>
            </Text>
            <Text as="p" variant="lg-medium">
              삭제 후 복구할 수 없습니다.
            </Text>
          </Flex>
        </Stack>
      }
    />
  );
};

export default DeletePdfFileModal;
